import createIcon from '../../createIcon';

/**
 * @component @name Opacity
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcuNjYgNy45OTQ5N0wxMiAyLjM0NDk3TDYuMzQgNy45OTQ5N0M0Ljc4IDkuNTU0OTcgNCAxMS42MzUgNCAxMy42MzVDNCAxNS42MzUgNC43OCAxNy43NDUgNi4zNCAxOS4zMDVDNy45IDIwLjg2NSA5Ljk1IDIxLjY1NSAxMiAyMS42NTVDMTQuMDUgMjEuNjU1IDE2LjEgMjAuODY1IDE3LjY2IDE5LjMwNUMxOS4yMiAxNy43NDUgMjAgMTUuNjM1IDIwIDEzLjYzNUMyMCAxMS42MzUgMTkuMjIgOS41NTQ5NyAxNy42NiA3Ljk5NDk3Wk02IDEzLjk5NUM2LjAxIDExLjk5NSA2LjYyIDEwLjcyNSA3Ljc2IDkuNTk0OTdMMTIgNS4yNjQ5N0wxNi4yNCA5LjY0NDk3QzE3LjM4IDEwLjc2NSAxNy45OSAxMS45OTUgMTggMTMuOTk1SDZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Opacity = createIcon('Opacity', [
  [
    'path',
    {
      d: 'M17.66 7.99497L12 2.34497L6.34 7.99497C4.78 9.55497 4 11.635 4 13.635C4 15.635 4.78 17.745 6.34 19.305C7.9 20.865 9.95 21.655 12 21.655C14.05 21.655 16.1 20.865 17.66 19.305C19.22 17.745 20 15.635 20 13.635C20 11.635 19.22 9.55497 17.66 7.99497ZM6 13.995C6.01 11.995 6.62 10.725 7.76 9.59497L12 5.26497L16.24 9.64497C17.38 10.765 17.99 11.995 18 13.995H6Z',
      key: 'iip0ai',
    },
  ],
]);

export default Opacity;
